import React, { useEffect, useState } from 'react';
import { Input } from '../../inputs';
import { search } from './locale';
import SearchBackground from '../../../assets/add-ons/search.svg';

// styles
import styles from './styles-module.css';

export const Search = ({
  intl,
  onUpdateSearchText,
  selectedStatus,
  onShowLoadingState,
  showLoadingState,
  placeholder,
  customIcon,
  searchValue,
  searchTextValue,
  customWrapperClass,
}) => {
  const [searchText, setSearchText] = useState(searchValue || '');
  const [debounce, setDebounce] = useState(null);
  const inputPlaceholder = placeholder || intl.formatMessage(search.placeholder);

  useEffect(() => {
    setSearchText(''); 
  }, [selectedStatus])

  useEffect(() => {
    setSearchText(searchValue); 
  }, [searchValue])

  useEffect(() => {
    !searchTextValue && setSearchText('');
  }, [searchTextValue])

  const updateSearchText = (event) => {
    const text = event.target.value;
    setSearchText(text);
    setDebounce(clearTimeout(debounce));

    if (text) {
      // update to show loading spinner while typing
      if (!showLoadingState) onShowLoadingState();

      // update query only after 1500 of straight no typing
      setDebounce(setTimeout(() => {
        onUpdateSearchText(text);
      }, 1500));
    }
    else {
      onUpdateSearchText(text);
    }
  }

  const renderSearchIcon = () => {
    if (customIcon) return customIcon;
    return <SearchBackground className={styles.searchIcon} color="black" />;
  }

  return (
    <div className={`${styles.wrapper} ${customWrapperClass}`}>
      <Input
        placeholder={inputPlaceholder}
        type="text"
        value={searchText}
        onChange={updateSearchText}
        className={`${styles.search} custom-input`}
        icon={renderSearchIcon}
      />
    </div>
  );
}

export default Search;
